import React from "react";

const ToastError = ({ message }) => {
  return (
    <div className="flex h-[85px] items-center bg-red-50 relative w-[534px]">
      <div className="h-full bg-red-200 w-4" /> 
        <div className="flex items-center ml-4 pr-[50px]  w-full">
            <img src="/icons/error-toast.svg" alt="success" />
            <p className="text-gray-800 text-body-md ml-3"><span className="font-semibold">Error:</span> <span dangerouslySetInnerHTML={{ __html: message }} /></p>
        </div>
    </div>
  );
};

export default ToastError;
